"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postCoreDataDictionaryViewAsyncSlice = void 0;
const add_1 = require("./add.js");
const name_1 = require("./name.js");
const _api_1 = require("../../../api/index.js");
const xuder_1 = require("@sonar-software/xuder");
exports.postCoreDataDictionaryViewAsyncSlice = (0, xuder_1.createPostAsyncSlice)({
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request, response) => add_1.addCoreDataDictionaryViewsSyncSlice.syncActionCreator({
                columns: request.columns,
                filter: request.filter,
                id: response.viewId,
                name: request.viewName,
                ordering: request.ordering
            })
        ]
    },
    name: name_1.CoreDataDictionaryViewsName,
    receive: true,
    request: true,
    requestHandler: _api_1.postDataDictionaryView,
    yieldType: xuder_1.SagaYieldType.Every
});
//# sourceMappingURL=post.js.map